
import SsInput from './SsInput'
import SsFile from './SsFile'
import SsPopover from './SsPopover'
import SsTextarea from "./SsTextarea";

export default {
    install (Vue) {
        Vue.component('SsInput', SsInput);
        Vue.component('SsFile', SsFile);
        Vue.component('SsPopover', SsPopover);
        Vue.component('SsTextarea', SsTextarea);
    }
}

export { SsInput, SsFile, SsPopover };